import getAdjChanges from './getAdjChanges'

export default function hasCharacterSheetChanges({
  changes = {},
  original_adjs = [],
  character = {},
} = {}) {
  const changed_profile = changes.profile ?? {}
  const changed_chars = changes.chars ?? []
  const changed_skills = changes.skills ?? []
  const changed_runes = changes.runes ?? []
  const changed_items = changes.items ?? []
  const changed_counts = changes.counts ?? []
  const changed_spells = changes.spells ?? []
  const changed_armour_locations = changes.armour_locations ?? []

  if (changed_profile?.payload && Object.keys(changed_profile.payload).length > 0) {
    return true
  }

  if (
    changed_chars.length > 0 ||
    changed_skills.length > 0 ||
    changed_runes.length > 0 ||
    changed_items.length > 0 ||
    changed_counts.length > 0 ||
    changed_spells.length > 0 ||
    changed_armour_locations.length > 0
  ) {
    return true
  }

  const adj_categories = ['characteristic', 'ability', 'characteristic-skill', 'skill']
  let changed_adjs = []

  adj_categories.forEach((adj_category) => {
    changed_adjs.push(
      ...getAdjChanges({
        category: adj_category,
        original_adjs: original_adjs.filter(
          (a) => a.category === adj_category && (a.editable === true || a.persistable === true),
        ),
        character,
      }),
    )
  })

  const deletedSkillNames = changed_skills
    .filter((entry) => entry?.action === 'DELETE')
    .map((entry) => entry?.name)
    .filter(Boolean)

  if (deletedSkillNames.length > 0) {
    changed_adjs = changed_adjs.filter(
      (adj) => !(adj.category === 'skill' && deletedSkillNames.includes(adj.name)),
    )
  }

  return changed_adjs.length > 0
}
